import { Component } from "react";

/**
 * Global error boundary — prevents a single component crash from taking down
 * the entire site (which would show a blank white screen to visitors).
 * Instead we render a graceful, on-brand fallback with the phone/email.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Site-level error captured:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-white text-slate-950 flex flex-col">
        <header className="border-b border-slate-200">
          <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center gap-3">
            <div className="h-9 w-9 grid place-items-center bg-[#0052FF] text-white font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>H</div>
            <div className="leading-tight">
              <div className="text-[15px] font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>HCS Computers AI</div>
              <div className="text-[10px] text-slate-500 uppercase tracking-widest">IT Training & Consultancy</div>
            </div>
          </div>
        </header>
        <main className="flex-1 grid place-items-center px-6">
          <div className="max-w-xl text-center py-16">
            <div className="text-xs uppercase tracking-widest text-slate-500">Momentary hiccup</div>
            <h1 className="mt-3 font-bold text-3xl md:text-4xl" style={{ fontFamily: "Outfit, sans-serif" }}>
              We&apos;ll be right back.
            </h1>
            <p className="mt-4 text-slate-600 text-base leading-relaxed">
              Our team has been notified. In the meantime, please reach us directly — we&apos;re happy to answer any question about our Salesforce, AWS, Mulesoft, and IBM programs.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3 text-sm">
              <a href="tel:+918549000328" className="inline-flex items-center gap-2 bg-[#0052FF] hover:bg-[#0040CC] text-white font-medium px-5 py-3 transition-colors">
                Call +91 85490-00328
              </a>
              <a href="mailto:infohimaniconsult@gmail.com" className="inline-flex items-center gap-2 border border-slate-900 hover:bg-slate-900 hover:text-white font-medium px-5 py-3 transition-colors">
                Email us
              </a>
              <button onClick={() => window.location.reload()} className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-950 font-medium px-3 py-3">
                Retry
              </button>
            </div>
          </div>
        </main>
        <footer className="border-t border-slate-200 py-6">
          <div className="mx-auto max-w-7xl px-6 lg:px-10 text-xs text-slate-500 text-center">
            © {new Date().getFullYear()} HCS Computers AI. All rights reserved.
          </div>
        </footer>
      </div>
    );
  }
}
